import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TimeslotList } from "../../Redux/Actions/agentActions";
import { columnsTimeslot } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponentsCp";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import DisableTimeslotModal from "./disableTimeslotModal";  


const ListTimeSlot = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const [disableModalVisible, setDisableModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const { timeslots, timeslotLoading, timeslotCount } = useSelector((state) => state.agents);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleStatusChange = async (record, action) => {
    if (action === "disable") {
      setSelectedRecord(record);
      setDisableModalVisible(true);
      return;
    }

    let payload = { id: record._id };
    if (action === "block") {
      payload.status = "BLOCK";
    } else if (action === "unblock") {
      payload.status = "UNBLOCK";
    } else {
      payload.status = action;
    }

    fetchDetails(pagination.current, pagination.pageSize);
  };

  const fetchDetails = useCallback(
    async (page, pageSize, role, showLoader = true) => {
      const teamData = {
        page,
        limit: pageSize,
        is_deleted: false,
        role: ["agent"],
        search: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      try {
        await dispatch(TimeslotList(teamData, showLoader));
        if (!showLoader) {
          toast.success("Time Slot list refreshed");
        }
      } catch {
        if (!showLoader) {
          toast.error("Failed to refresh Time Slot list");
        }
      }
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (timeslotCount) {
      setPagination((prevData) => ({ ...prevData, total: timeslotCount }));
    }
  }, [timeslotCount]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponent
        h3heading="Time Slot List"
        setState={setSearchQuery}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        dataSource={(Array.isArray(timeslots) && timeslots) || []}
        pagination={pagination}
        onChange={handleTableChange}
        loading={timeslotLoading}
        columns={columnsTimeslot(pagination.current, pagination.pageSize, handleStatusChange)}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />

      {/* Disable Timeslot Modal */}
      <DisableTimeslotModal
        visible={disableModalVisible}
        record={selectedRecord}
        onClose={() => {
          setDisableModalVisible(false);
          setSelectedRecord(null);
        }}
        onSuccess={() => fetchDetails(pagination.current, pagination.pageSize)}
      />
    </>
  );
};

export default ListTimeSlot;